export async function jsonRequest(path, { method, data } = {}) {
  const response = await fetch(path, {
    method,
    credentials: "same-origin",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      "X-CSRF-Token": csrfToken(),
    },
    body: data ? JSON.stringify(data) : undefined,
  });

  if (!response.ok) {
    const message = await errorMessage(response);
    throw new Error(message || `Request failed (${response.status})`);
  }

  if (response.status === 204) return null;
  return response.json();
}

function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content || "";
}

async function errorMessage(response) {
  try {
    const json = await response.json();
    return json.error || json.message;
  } catch (_error) {
    return "";
  }
}
